import src from "IMAGE";
export default { src, width: 800, height: 533, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/webp;base64,UklGRlgAAABXRUJQVlA4TEwAAAAvBwABAM1VICICHggwDQAAAIBt9QcAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACodgAAICLyYfjRCu54hV4ajHNd15XKkIkE"};
